export function BenchmarkMetric({
  label,
  value,
  context,
}: {
  label: string;
  value: string;
  context: string;
}) {
  const percentage = /^\d+(?:\.\d+)?%$/.test(value)
    ? Number.parseFloat(value)
    : null;

  return (
    <span className="benchmark-metric">
      <small>{label}</small>
      <strong>{value}</strong>
      <small className="benchmark-metric-context">{context}</small>
      {percentage !== null && (
        <span className="benchmark-measure" aria-hidden="true">
          <span style={{ width: `${percentage}%` }} />
        </span>
      )}
    </span>
  );
}
